<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 min-h-screen overflow-hidden">
    <!-- Header -->
    <div class="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
      <div class="sm:w-0 sm:flex-1">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Servicing Our Members</h3>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis">Fee Schedule</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1"  v-if="stateCount['Others'] > 0">
              <div class="tooltip mt-1">
                Attorney Fee Reimbursement Schedule pdf
                <a  :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=Attorney_Fee_Reimbursement_Schedule.pdf&folder=agreement_pdfs'
                    ">
                  <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer"></i>
                </a>
                <span class="tooltip-text">Download</span>
              </div>
            </li>
            <li class="py-1" v-if="stateCount['CA'] > 0">
              <div class="tooltip mt-1">
                USL Fee Schedule - California pdf
                <a :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=USL Fee Reimbursement Schedule - California.pdf&folder=agreement_pdfs'
                    ">
                  <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer"></i>
                </a>
                <span class="tooltip-text">Download</span>
              </div>
            </li>
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">Fee for Services Attorney Agreement</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">
              <div class="tooltip mt-1">
                Fee for Services Attorney Agreement
                <a  :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=Fee_for_Services_Attorney_Agreement_new.pdf&folder=agreement_pdfs'">
                  <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer"></i>
                </a>
                <span class="tooltip-text">Download</span>
              </div>
            </li>
          
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">Documents for Servicing Members</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">
              <div class="tooltip mt-1">
                Member Acknowledgment of Services Rendered Form for Estate Planning Matters (Wills & Trusts)
                <a :href="
                  API_BASE +
                    'downloadAggreementFiles.php?name=Member_Acknowledgement_of_Services_Rendered_new.pdf&folder=agreement_pdfs'
                ">
                  <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer"></i>
                </a>
                <span class="tooltip-text">Download</span>
              </div>
              This form is required for Estate Planning Matters (Wills & Trusts) and will need to be signed by the
              Member. You will need to submit the signed form with your claim upon completion of the matter.
            </li>
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">Member Assignments - Matter Cases</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">When we assign a Member to you, you will always receive an assignment e-mail. The subject
              line of the e-mail will be "Assigned to Attorney - Member Name, USL Member # ______". </li>
            <li class="py-1">When you receive the “Assigned to Attorney” email, within the email there is a link for you
              to accept/decline the case. Once you click that link, it will take you to a page where you can confirm
              whether you can accept or decline the case. If you choose to decline the case, we ask that you provide us
              with information as to why you chose to decline so that we can reassign the Member and make adjustments as
              needed. </li>
            <li class="py-1">For covered matters, the email will instruct you to contact our Authorizations Department
              (once you have had the consultation) to determine the coverage the Member is eligible for under his or her
              plan and to obtain authorization to proceed beyond the consultation. This is very important because not
              all our Members have the same coverage. </li>
            <li class="py-1">For non-covered services, the first paragraph of the email will state *REFERRAL and request
              that you provide the Member with a free initial consultation and that any services the Member retains you
              to provide, you will bill the Member directly at a 33% discounted rate. </li>
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">Request Additional Authorization on
          Matter Cases</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">For your convenience, there are several ways to contact our Authorizations Department to
              obtain coverage information or request authorization. The preferred method is by utilizing the
              Authorization Request system within your Attorney Portal. You may also call our attorney dedicated number
              (844) 894-5297, or respond to the assignment email you receive.</li>
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">Member Assignments - CDL Cases</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">Covered CDL Case citations will be emailed to you with case information, a copy of the
              citation and member contact information. After reviewing the case, please respond within 2 business days,
              to the initial email advising of your acceptance of the case. Please note that we must receive
              confirmation from your office to complete the assignment process. Upon acceptance, you will receive a
              second email confirming the acceptance of the case. </li>
            <li class="py-1">Per your Attorney Application, if you chose to extend a 33% discount off your normal hourly
              rate, U.S. Legal Services will send member referral citations to your office. These referrals will clearly
              state the case is a referral and you will bill the member directly. Please advise our office by responding
              to the initial email, whether the plan member retains your services. Upon completion of the case, please
              complete and return disposition form attached to the referral email. </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between mt-5">
      <div class="sm:w-0 sm:flex-1">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Filing Claims</h3>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <div class="text-sm">The preferred method of filing a claim is online. To file a claim, please visit the Claims
          section in your Attorney Portal. All claims must be filed within 90 days of completion. Claims submitted after
          90 days are subject to review and denial. </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-2">Matter Case Claims</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">
              Matter Case claims received prior to Friday every week will be processed for payment Monday of the
              following week. There are some situations where you will need to upload supporting documentation for the
              claim. These will be notated when you are filing the claim.</li>
          </ul>
        </div>
        <p class="text-lg text-gray-500 overflow-hidden overflow-ellipsis mt-4">CDL Case Claims</p>
        <hr class="m-2">
        <div class="ml-7 text-sm px-2">
          <ul class="list-disc">
            <li class="py-1">When filing a claim for a covered CDL case citation(s), you will need to upload a
              disposition from the courts. If a disposition from the courts is not available, please provide a written
              statement regarding the outcome of the case on your firm's letterhead. </li>
            <li class="py-1">CDL Case claims received prior to the 24th of the month will be processed for payment that
              month and checks will be cut on the 5th business day of the month. CDL Case claims received after the 24th
              of the month, will be processed the following month. </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Constants from "../constants.ts"; // importing constant resubale variables.

export default {
  name: "Help Information",
  data() {
    return {
      API_BASE: Constants.API_BASE,
      stateCount: { CA: 0, Others: 0 }
    }
  },
  mounted() {
    this.$store.dispatch("getAttProfileData");
  },
  created() {
    // if attorney logged in and submitted enrollment form.
    this.$store.watch(
      () => this.$store.state.profile_data,
      value => {
        if (value != null) {
          value.practice_states.forEach(el => {
            if(el.deleted!=1 && el.deleted!='1'){
            if(el.state_code == "CA"
          ){
            this.stateCount["CA"] = this.stateCount["CA"] + 1;
          }else {
                  this.stateCount["Others"] =
                    this.stateCount["Others"] + 1;
                }
          }
        });
        }
      }
    );
  }
};
</script>
